<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="numberOfPages !== 0" ref="pagination" class="pagination-container">
    <Paginate
      v-model="queryPagination"
      :page-count="numberOfPages"
      :page-range="3"
      :margin-pages="1"
      :click-handler="changeQueryString"
      :prev-text="`<div class='icon-search-prev'/>`"
      :next-text="`<div class='icon-search-next'/>`"
      container-class="pagination-list"
      page-class="pagination-item"
    />
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate'

/**
 * Display diferent icon logo depending on type
 * @example [none]
 */
export default {
  name: 'PBDPagination',
  components: {
    Paginate,
  },
  props: {
    /**
     * Max number of items for page
     */
    itemsForPage: {
      type: Number,
    },
    /**
     * Object with search axios result
     */
    dataSearch: {
      type: Object,
    },
    type: {
      type: String,
    },
  },
  data() {
    return {
      currentPage: 1,
    }
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.dataSearch.count / this.itemsForPage)
    },
    queryPagination: {
      get: function () {
        if (this.type === 'type') {
          if (this.$route.query && this.$route.query.itemsPage) return parseInt(this.$route.query.itemsPage)
        } else if (this.type === 'down-type') {
          if (this.$route.query && this.$route.query.downPage) return parseInt(this.$route.query.downPage)
        } else if (this.type === 'language') {
          if (this.$route.query && this.$route.query.langPage) return parseInt(this.$route.query.langPage)
        } else if (this.type === 'country') {
          if (this.$route.query && this.$route.query.countryPage) return parseInt(this.$route.query.countryPage)
        }
        return 1
      },
      set: function (val) {
        this.currentPage = val
      },
    },
  },
  methods: {
    /**
     * Update page query params with page value obtained by params
     * @public This is a public method
     * @param {Number} page Number of page
     */
    changeQueryString(page) {
      let currQuery = {...this.$route.query}
      if (this.type === 'type' && page !== parseInt(this.$route.query.itemsPage)) {
        currQuery.itemsPage = page
      } else if (this.type === 'down-type' && page !== parseInt(this.$route.query.downPage)) {
        currQuery.downPage = page
      } else if (this.type === 'language' && page !== parseInt(this.$route.query.langPage)) {
        currQuery.langPage = page
      } else if (this.type === 'country' && page !== parseInt(this.$route.query.countryPage)) {
        currQuery.countryPage = page
      }
      this.$emit('toggle-data-loading')
      let element = this.$refs['pagination'].parentElement.parentElement
      let header = document.getElementById('header')?.offsetHeight || 0
      let top = element.offsetTop - header - (header !== 0 ? 45 : 10)
      this.$router.push({
        query: currQuery,
      }).then(() => {
        window.scrollTo(0, top)
      })
    },
  },
}
</script>

<style lang="stylus">
.pagination-container
  display: flex
  align-items: center
  margin-top: vw(10px)

  .mobile &
    margin-top: vw(25px)

.pagination-list
  display: flex
  align-items: center
  color: $grey
  font-weight: 300
  gap: vw(10px)

  > li
    width: vw(20px)

    &:first-child
      margin-right: vw(5px)

    &:last-child
      margin-left: vw(5px)

    &:hover
      color: #000

      .icon-search-next,
      .icon-search-prev
        background-color: #000

    > a
      m-font-size(16, 26)
      display: block
      text-align: center

  .active
    color: #000
    font-weight: 700

    > a
      cursor: default

  .disabled
    opacity: 0.5
    pointer-events: none

  .icon-search-next,
  .icon-search-prev
    m-icon("chevron-right", 20)
    cursor: pointer

  .icon-search-prev
    transform: rotate(180deg)
</style>
